export const FALLBACK_AVATAR = process.env.PUBLIC_URL + '/avatar.png';